/**
 * Page-about ESM entry point.
 *
 * Loaded only on the page.about template via a
 * `{% if template.suffix == 'about' %}` gate in content-for-footer.liquid.
 *
 * AI: Entirely written by AI
 * Date: 2026-05-04
 * Model: Claude Opus 4.7
 *
 * [EntryPageAbout]
 */

import { log } from './log.js';
import './page-about.js';

log('[App] entry-page-about loaded');
